import { render, staticRenderFns } from "./Efficacy.vue?vue&type=template&id=42cd87ad&scoped=true&"
import script from "./Efficacy.vue?vue&type=script&lang=js&"
export * from "./Efficacy.vue?vue&type=script&lang=js&"
import style0 from "./Efficacy.vue?vue&type=style&index=0&id=42cd87ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd87ad",
  null
  
)

export default component.exports